import { openContextModal } from "@mantine/modals";
import { getI18n } from "react-i18next";

import { ModalInnerProps } from "./LinkShareModal";

export const openLinkShareModal = (params: ModalInnerProps) =>
	openContextModal({
		modal: "linkShare",
		innerProps: params,
		title: String(getI18n().t("link_share_modal.title"))
	});
